import {Injectable} from '@angular/core';
import {Area, Home, SideBar, Step} from '../../@shared';
import {RfqPropertyDto} from '../../@api';

@Injectable({
    providedIn: 'root'
})
export class RfqDataService {
    public steps: Step[];
    public activeStep: number;
    public sideBar: SideBar = {};
    public home: Home;
    public area: Area;
    public sunrise: string;
    public sunset: string;
    public householdSize: string;
    public information: string;
    public importance: string;
    public coverage: number;
    public property: RfqPropertyDto = {}
    public contact: any = {}
}
